import type { WorkplaceAnalyticsFeatureFlagValue } from "@clipboard-health/flag-backend-main";
import { isNonEmptyArray } from "@clipboard-health/util-ts";

export function canAccessWorkplaceAnalytics(params: {
  flag: WorkplaceAnalyticsFeatureFlagValue;
  hasAdminPrivileges: boolean;
  canViewBilling: boolean;
}): boolean {
  const { flag, hasAdminPrivileges, canViewBilling } = params;
  return (
    flag.enabled &&
    isNonEmptyArray(flag.tables) &&
    // internalUseOnly keeps this CBH-admin-only; otherwise it requires billing
    // access, mirroring the backend gate. canViewBilling already folds in admin
    // privileges, so CBH admins/employees pass either branch.
    (flag.internalUseOnly ? hasAdminPrivileges : canViewBilling)
  );
}
